import * as React from 'react';

//other deps
import _ from 'lodash';
import { Localized } from '@fluent/react';

//redux
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';

//schemes
import * as schemes from '../../../schemes';

//components
import Builder from 'app/containers/Builder';

//types
import { EmptyCar } from 'app/models';
import { EmptyCarActions } from 'app/actions';
import { SchemeProps } from 'app/containers/Builder/props';

//----------------------------------------------------------
// InsuranceItem
//----------------------------------------------------------
class InsuranceItem extends React.Component<InsuranceItem.Props, InsuranceItem.State> {
	private builder: Builder | null = null;

	public state: InsuranceItem.State = {
		scheme: _.cloneDeep(schemes.insurance),
		form: {},
	};

	constructor(props: InsuranceItem.Props) {
		super(props);
	}

	public async componentDidMount() {
		this.applyDefaults();
	}

	private applyDefaults = () => {
		const { builder } = this;

		if (builder) {
			const allowed = ['number'];

			for (const key of allowed) {
				const ref = builder.formRefs.get(key);
				const value = (this.props?.insurance as any)?.[key] ?? null;

				if (ref && value) ref.updateValue(value);
			}
		}
	};

	private onUpdate = async (name: string, value: any) => {
		const { form } = this.state;
		const { updateInsuranceData } = this.props;

		this.setState({
			form: {
				...form,
				[name]: value,
			},
		});

		if (updateInsuranceData) {
			updateInsuranceData({
				[name]: value,
			});
		}
	};

	public render() {
		const { scheme } = this.state;

		const builderProps = {
			getRef: (node: Builder | null) => {
				this.builder = node;
			},
			scheme: scheme,
			onUpdate: this.onUpdate,
		};

		return (
			<div className='insurance item opened'>
				<div className='titlebar'>
					<div className='titles'>
						<div className='header'>
							<Localized id='transport-insurances-title' />
						</div>
					</div>
				</div>

				<div className='form'>
					<Builder {...builderProps} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch) =>
	bindActionCreators(
		{
			updateInsuranceData: EmptyCarActions.updateInsuranceData,
		},
		dispatch,
	);

export default connect<InsuranceItem.StateProps, InsuranceItem.DispatchProps, InsuranceItem.ExternalProps>(
	mapStateToProps,
	mapDispatchToProps,
)(InsuranceItem);

export namespace InsuranceItem {
	export type Props = StateProps & DispatchProps & ExternalProps;

	// Props from redux mapState
	export interface StateProps {}

	// Dispatch properties function from redux
	export interface DispatchProps {
		updateInsuranceData?: (insurance: Partial<EmptyCar.Insurance>) => void;
	}

	// Props from parent element e.g <Cmp custom={true} />
	export interface ExternalProps {
		insurance: EmptyCar.Insurance | null;
	}

	// Main component state
	export interface State {
		form: { [name: string]: any };
		scheme: SchemeProps.Union[];
	}
}
